module.exports = __webpack_public_path__ + "media/volvo/assets/images/volvo_xc90@2x-c53aba33609d0a562ee66711ec1ad8e6.png";